import L from 'leaflet';
import { isEmpty, forEach, isEqual } from 'lodash';
import React from 'react';
import { renderToString } from 'react-dom/server';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as annotationOps from '../../api/Annotations/annotation-operations';
import * as templateOps from '../../api/AnnotationTemplates/annotation-template-operations';
import { LIBRARY_ICON_TYPES } from '../../api/AnnotationTemplates/AnnotationTemplates';

const Z_INDEX = 2000;

/**
 * Draws the video annotations in the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object[]} arg.annotations - The video annotations.
 * @param {?object} arg.annotationsLayer - The geoJSON layer where the annotations will be painted.
 * @param {object} arg.selectAnnotation - The geoJSON layer where the annotations will be painted.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @param {Function}  [arg.onClickFunction] - Function for click on annotation event.
 * @returns {object} The leaflet layer where the annotations are painted.
 */
const drawVideoAnnotations = ({
  leafletMap,
  annotations,
  annotationsLayer,
  isUpdate = false,
  onClickFunction = () => {},
  selectAnnotation = {}
}) => {
  let newAnnotationsLayerContainer = '';

  if (!isUpdate) {
    newAnnotationsLayerContainer = L.geoJSON().addTo(leafletMap);
  } else {
    newAnnotationsLayerContainer = annotationsLayer;
    newAnnotationsLayerContainer.clearLayers();
  }

  if (!isEmpty(annotations)) {
    forEach(annotations, annotation => {
      const annotationTemplate = annotationOps.getTemplate(annotation);
      const libraryIcon = templateOps.getLibraryIcon(annotationTemplate);
      let myAnnotationsLayer = L.geoJSON(annotationOps.getGeoJSON(annotation));
      if (libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME) {
        const iconAnnotation = templateOps.getIcon(annotationTemplate);
        const fontAwesomeIcon = L.divIcon({
          html: renderToString(
            <FontAwesomeIcon
              style={{ fontSize: '20px', marginTop: '0px', marginLeft: '-10px' }}
              icon={iconAnnotation}
              color={isEqual(annotation, selectAnnotation) ? 'green' : 'blue'}
            />
          ),
          className: 'myDivIcon'
        });
        myAnnotationsLayer = L.geoJSON(annotationOps.getGeoJSON(annotation), {
          pointToLayer(feature, latlng) {
            return L.marker(latlng, { icon: fontAwesomeIcon });
          }
        });
      }
      if (libraryIcon === LIBRARY_ICON_TYPES.SVG) {
        const iconAnnotation = templateOps.getIcon(annotationTemplate);
        const svgAnnotation = templateOps.getIconSvg(annotationTemplate);
        const svgIcon = L.divIcon({
          html: renderToString(
            <img
              src={svgAnnotation}
              alt={iconAnnotation}
              style={{ marginTop: '-10px', marginLeft: '-20px', width: '35px', height: '35px' }}
            />
          ),
          className: 'myDivIcon'
        });
        myAnnotationsLayer = L.geoJSON(annotationOps.getGeoJSON(annotation), {
          pointToLayer(feature, latlng) {
            return L.marker(latlng, { icon: svgIcon });
          }
        });
      }

      newAnnotationsLayerContainer.addLayer(
        myAnnotationsLayer
          .getLayers()[0]
          .setZIndexOffset(Z_INDEX)
          .on('click', () => onClickFunction(annotation))
          .bindPopup(templateOps.getName(annotationOps.getTemplate(annotation)))
      );
    });
  }
  return newAnnotationsLayerContainer;
};
export default drawVideoAnnotations;
